// Gig lifecycle helpers (frontend view of server-authoritative status).

export const GIG_STATUS = {
  accepting_applications: { label: "Accepting Applications", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  applications_closed: { label: "Applications Closed", tone: "bg-slate-100 text-slate-700 border-slate-200" },
  event_started: { label: "Event Started", tone: "bg-amber-50 text-amber-800 border-amber-200" },
  completed: { label: "Completed", tone: "bg-slate-100 text-slate-500 border-slate-200" },
  cancelled: { label: "Cancelled", tone: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const ALLOWED_TRANSITIONS = {
  accepting_applications: ["applications_closed", "event_started", "completed", "cancelled"],
  applications_closed: ["event_started", "completed", "cancelled"],
  event_started: ["completed", "cancelled"],
  completed: [],
  cancelled: [],
};

export const isLive = (op) => op?.is_live === true || op?.status === "accepting_applications";
export const isAcceptingApplications = (op) => isLive(op);
